import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './business-trip-get-list.actions';
import { BusinessTripGetListState } from './business-trip-get-list.state';

/**
 * businessTripGetList initial state
 */
export const businessTripGetListInitialState: BusinessTripGetListState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for BusinessTripGetList Store
 */
export const businessTripGetListReducerFeatures: ReducerTypes<BusinessTripGetListState, ActionCreator[]>[] = [
  on(actions.setBusinessTripGetList, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateBusinessTripGetList, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetBusinessTripGetList, () => businessTripGetListInitialState),

  on(actions.cancelBusinessTripGetListRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failBusinessTripGetList, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setBusinessTripGetListFromApi, actions.updateBusinessTripGetListFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * BusinessTripGetList Store reducer
 */
export const businessTripGetListReducer = createReducer(
  businessTripGetListInitialState,
  ...businessTripGetListReducerFeatures
);
